import moment from "moment";
import React from "react";
import { Label, Row, Col } from "reactstrap";
import { TableDateFormat } from "../../Dashboard/DashboardVariables";

function PersonalInfo(props) {
	const { currentUser } = props;
	return (
		<div className="formInfoContainer">
			<div className="formInfoContainerHeader">
				<Label sm={12}>Personal Information</Label>
			</div>
			<Col>
				<Row className="py-2 px-2">
					<Col md={12} lg={3}>
						<div className="formDetailHeader">
							<div>Employee Name</div>
						</div>
					</Col>
					<Col md={12} lg={3}>
						<p className="formValueContainer">
							{currentUser?.employeeName}
						</p>
					</Col>
					<Col md={12} lg={3}>
						<div className="formDetailHeader">
							<div>Employee Code</div>
						</div>
					</Col>
					<Col md={12} lg={3}>
						<p className="formValueContainer">
							{currentUser?.employeeCode}
						</p>
					</Col>
					<Col md={12} lg={3}>
						<div className="formDetailHeader">
							<div>Department</div>
						</div>
					</Col>
					<Col md={12} lg={3}>
						<p className="formValueContainer">
							{currentUser?.employeeDepartment}
						</p>
					</Col>
					<Col md={12} lg={3}>
						<div className="formDetailHeader">
							<div>Date</div>
						</div>
					</Col>
					<Col md={12} lg={3}>
						<p className="formValueContainer">
							{moment(Date.now()).format(TableDateFormat)}
						</p>
					</Col>
				</Row>
			</Col>
		</div>
	);
}

export default PersonalInfo;
